var render = function render(){
  var _vm$application, _vm$application$resum, _vm$application$resum2, _vm$application2, _vm$application2$resu, _vm$application2$resu2, _vm$application3, _vm$application3$resu, _vm$application3$resu2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    staticStyle: {
      "overflow": "initial"
    },
    attrs: {
      "outlined": "",
      "rounded": "lg"
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-row', {
    staticClass: "ma-0 pa-10",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "page-text--lg",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    staticClass: "mr-10 mr-md-20",
    attrs: {
      "color": "grey darken-1",
      "size": "30"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.profileSrc
    }
  }, [_c('v-fade-transition', [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.profileSrc,
      expression: "!profileSrc"
    }],
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-account")])], 1)], 1)], 1), _vm._v(" " + _vm._s((_vm$application = _vm.application) === null || _vm$application === void 0 ? void 0 : (_vm$application$resum = _vm$application.resume) === null || _vm$application$resum === void 0 ? void 0 : (_vm$application$resum2 = _vm$application$resum.personalInformation) === null || _vm$application$resum2 === void 0 ? void 0 : _vm$application$resum2.name) + " "), _c('span', {
    staticClass: "font-size-14 font-weight-regular grey-9--text"
  }, [_vm._v(" (" + _vm._s((_vm$application2 = _vm.application) === null || _vm$application2 === void 0 ? void 0 : (_vm$application2$resu = _vm$application2.resume) === null || _vm$application2$resu === void 0 ? void 0 : (_vm$application2$resu2 = _vm$application2$resu.personalInformation) === null || _vm$application2$resu2 === void 0 ? void 0 : _vm$application2$resu2.genderText) + ", " + _vm._s((_vm$application3 = _vm.application) === null || _vm$application3 === void 0 ? void 0 : (_vm$application3$resu = _vm$application3.resume) === null || _vm$application3$resu === void 0 ? void 0 : (_vm$application3$resu2 = _vm$application3$resu.personalInformation) === null || _vm$application3$resu2 === void 0 ? void 0 : _vm$application3$resu2.age) + ") ")])], 1), _c('v-col', _vm._l(_vm.infoItems, function (text) {
    return _c('v-row', {
      key: text,
      staticClass: "grey-6--text",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "grey lighten-1"
      }
    }, [_vm._v("mdi-circle-small")])], 1), _vm._v(" "), _c('v-col', [_vm._v(_vm._s(text))])], 1);
  }), 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    attrs: {
      "width": "220"
    }
  }, [_c('v-select', _vm._b({
    class: `meeting-status-item-date-${_vm.className}`,
    attrs: {
      "value": _vm.schedule.date,
      "items": _vm.scheduleDateItems,
      "menuProps": {
        attach: `.meeting-status-item-date-${_vm.className}`
      }
    },
    on: {
      "change": function (date) {
        return _vm.save({
          date
        });
      }
    }
  }, 'v-select', Object.assign({}, _vm.attrs_input, {
    loading: _vm.loading
  }), false))], 1)], 1), _c('v-col', {
    staticClass: "d-flex flex-column",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    attrs: {
      "width": "220"
    }
  }, [_c('v-select', _vm._b({
    class: `meeting-status-item-state-${_vm.className}`,
    attrs: {
      "value": _vm.schedule.state,
      "items": _vm.scheduleStates,
      "menuProps": {
        attach: `.meeting-status-item-state-${_vm.className}`
      }
    },
    on: {
      "change": function (state) {
        return _vm.save({
          state
        });
      }
    }
  }, 'v-select', Object.assign({}, _vm.attrs_input, {
    loading: _vm.loading
  }), false))], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }